import * as React from 'react';
import { Link, MemoryRouter, StaticRouter } from 'react-router';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Linkmuimateriallink, { LinkProps } from '@mui/material/Link';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "react-router": { Link, MemoryRouter, StaticRouter }, "@mui/material/styles": { ThemeProvider, createTheme }, "@mui/material/Button": Button, "@mui/material/Stack": Stack, "@mui/material/Link": Linkmuimateriallink } } });
export default ClientProvider;
